import { React, useEffect, useState } from "react";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Table,
  Select,
  Tooltip,
  Form,
  Spin,
  Col,
  Descriptions,
  Button,
  Divider,
  Modal,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { labelConfig, staticConfig } from "../../../../group.config";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import styles from "../../../../../../assets/styles/styles";
import Notiflix from "notiflix";

const { Text, Title } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
    handleOverdarftAllowed,
    lockinPeriodFrequencyTypeOptions,
    isLockInDefined,
    handleLockInPeriod,
    isMinReqBalEnforced,
    handleEnforceMin,
    isOverdraftAllowed,
    customerMemberList,
    customerDetails,
    setCustomerTableSource,
    customerTableSource,
    isModalOpen,
    setIsModalOpen,
    officeId,
    isCustomerSelected,
    setIsCustomerSelected,
  } = props;

  const handleCustomerDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = customerTableSource.filter(
          (item) => item.id !== key.id
        );
        setCustomerTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: labelConfig.id,
      dataIndex: "id",
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
    },
    {
      title: labelConfig.branch,
      dataIndex: "office",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        customerTableSource.length >= 1 ? (
          <Tooltip title={`Remove Customer`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleCustomerDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.currencyInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.currency} name="currency">
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.currency)}
              disabled
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.decimalPlaces} name="decimalPlaces">
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.decimalPlaces)}
              disabled
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.currencyInMultiplesOf}
            name="currencyInMultiplesOf"
          >
            <Input
              className="of-bold-disable-input"
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.currencyInMultiplesOf
              )}
              disabled
            />
          </Form.Item>
        </Col>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.interestInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.nominalAnnualInterest}
            name="nominalAnnualInterestRate"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.nominalAnnualInterest),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.nominalAnnualInterest
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCompoundingPeriod}
            name="interestCompoundingPeriodType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCompoundingPeriod,
                "select"
              )}
              options={interestCompoundingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestPostingPeriod}
            name="interestPostingPeriodType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestPostingPeriod,
                "select"
              )}
              options={interestPostingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculatedUsing}
            name="interestCalculationType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCalculatedUsing,
                "select"
              )}
              options={interestCalculationTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.additionalInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.daysInYear}
            name="interestCalculationDaysInYearType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.daysInYear),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.daysInYear,
                "select"
              )}
              options={interestCalculationDaysInYearTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.minimumOpeningBalance}
            name="minRequiredOpeningBalance"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.minimumOpeningBalance
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockInPeriod}
            name="lockinPeriodFrequency"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)}
              onChange={handleLockInPeriod}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockInPeriodType}
            name="lockinPeriodFrequencyType"
            rules={[
              {
                required: isLockInDefined,
                message: BOM.CheckReqFld(labelConfig.lockInPeriodType),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.lockInPeriodType,
                "select"
              )}
              options={lockinPeriodFrequencyTypeOptions}
              showSearch
              allowClear
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.applyWithdrawalFeeForTransfers}>
                {BOM.SubstringFormat(
                  labelConfig.applyWithdrawalFeeForTransfers,
                  20
                )}
              </Tooltip>
            }
            name="withdrawalFeeForTransfers"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.applyWithdrawalFeeForTransfers,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.isOverdraftAllowed}
            name="allowOverdraft"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.isOverdraftAllowed,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              onChange={handleOverdarftAllowed}
            />
          </Form.Item>
        </Col>
        {isOverdraftAllowed && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.maxOverdraftAmtLimit}
                name="overdraftLimit"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.maxOverdraftAmtLimit
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.nominalAnnualIntrstForOverdraft}>
                    {BOM.SubstringFormat(
                      labelConfig.nominalAnnualIntrstForOverdraft,
                      20
                    )}
                  </Tooltip>
                }
                name="nominalAnnualInterestRateOverdraft"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.nominalAnnualIntrstForOverdraft
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.minOverdraftForIntrstCalc}>
                    {BOM.SubstringFormat(
                      labelConfig.minOverdraftForIntrstCalc,
                      20
                    )}
                  </Tooltip>
                }
                name="minOverdraftForInterestCalculation"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.minOverdraftForIntrstCalc
                  )}
                />
              </Form.Item>
            </Col>
          </>
        )}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.enforceMinimumBalance}
            name="enforceMinRequiredBalance"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.enforceMinimumBalance,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              onChange={handleEnforceMin}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.minimumBalance}
            name="minimumBalance"
            rules={[
              {
                required: isMinReqBalEnforced,
                message: BOM.CheckReqFld(labelConfig.maxLienAmtLimit),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumBalance)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.customerInfo}
        </Title>
      </Divider>
      <AddCustomerModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setCustomerTableSource={setCustomerTableSource}
        customerTableSource={customerTableSource}
        customerDetails={customerDetails}
        customerMemberList={customerMemberList}
        officeId={officeId}
        isCustomerSelected={isCustomerSelected}
        setIsCustomerSelected={setIsCustomerSelected}
      />

      {customerTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {customerTableSource.length > 1
                ? labelConfig.selectedCustomers
                : labelConfig.selectedCustomer}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={customerTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </Form>
  );
};

export default TermsForm;

const AddCustomerModal = (props) => {
  const {
    setCustomerTableSource,
    customerTableSource,
    isModalOpen,
    setIsModalOpen,
    officeId,
    isCustomerSelected,
    setIsCustomerSelected,
    customerMemberList,
    customerDetails,
  } = props;

  const [useForm] = Form.useForm();
  const [customerData, setCustomerData] = useState([]);
  const [currentCustomerDetails, setCurrentCustomerDetails] = useState({});
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCustomerSave = (formValues) => {
    const newCustomer = customerDetails?.find(
      (item) => item.id === formValues.customerId
    );

    let foundCharge = customerTableSource.find(
      (item) => item.id === newCustomer?.id
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Customer allowed!");
      return;
    }
    setCustomerTableSource([...customerTableSource, newCustomer]);

    useForm.resetFields();
  };

  const onChangeCustomer = (customerParam) => {
    const currentCustomerDetails = customerDetails?.find(
      (item) => item.id === customerParam
    );
    setCurrentCustomerDetails(currentCustomerDetails);
    setIsCustomerSelected(true);
  };

  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: customerDetails ? currentCustomerDetails.id : "-",
      span: 3,
    },
    {
      key: "2",
      label: labelConfig.name,
      children: customerDetails ? currentCustomerDetails.name : "-",
      span: 3,
    },
    {
      key: "3",
      label: labelConfig.branch,
      children: customerDetails ? currentCustomerDetails.office : "-",
      span: 3,
    },
  ];

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        size="medium"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Add Customer from group"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleCustomerSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.selectCustomer}
              </Title>
            </Divider>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.customerList}
                name={"customerId"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.customer),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.customer,
                    "select"
                  )}
                  options={customerMemberList}
                  showSearch
                  onChange={onChangeCustomer}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
          {isCustomerSelected && (
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
          )}
        </Spin>
      </Modal>
    </Row>
  );
};
